<template>
  <standard-layout header="Kalender">
    <template v-slot:main>
      <div class="row">
        <div class="col-12 col-md-6">
          <reservation-calendar
              :selected-date="selectedDate"
              :min-date="now"
              @dayclick="dateSelected($event)"
          :updated="lastUpdate"/>
        </div>
      </div>
      <div class="h4 mt-4">
        <span v-if="selectedDate">{{ selectedDate|date }}</span>
        <span v-else class="text-secondary">bitte Datum wählen</span>
      </div>
      <div class="row" v-if="selectedDate">
        <div class="col-6">
          <div class="h5">Belegung</div>
          <ReservationDayCalendar :date="selectedDate"/>
        </div>
        <div class="col-6 pl-4">
          <div class="h5">Blockieren</div>
          <div v-if="selectedDate" class="form-inline">
            <button class="btn btn-sm btn-danger mt-2 mt-md-0 ml-md-2"
                    @click="blockDay">
              Tag blockieren
            </button>
            <button class="btn btn-sm btn-success ml-1 mt-2 mt-md-0 ml-md-2"
                    @click="unblockDay" :disabled="!blockAvailable">
              Tag freigeben
            </button>
          </div>
          <div class="d-none text-center">
            <button class="btn btn-danger m-5" @click="sendWeatherWarning">Kunden über Unwetter informieren</button>
          </div>
        </div>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import ReservationCalendar from "@/components/erp/ReservationCalendar";
import {DateTime} from "luxon";
import ReservationDayCalendar from "@/components/erp/ReservationDayCalendar";

export default {
  data() {
    return {
      page: {
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      },
      blockedTimes: [],
      selectedDate: null,
      reason: 'Closed',
      comment: null,
        lastUpdate: null
    }
  },
  computed: {
    now() {
      return new Date()
    },
    blockAvailable() {
      return this.blockedTimes.filter(bt => bt.reason === 'Closed').length > 0
    }
  },
  methods: {
    updateBlockedTimes() {
      return this.$api.get(`/calendar/${this.selectedDate.year}/${this.selectedDate.month}/${this.selectedDate.day}/blocked-times`)
          .then(response => {
              this.blockedTimes = response.data
              this.lastUpdate = Date.now()
          })
          .catch(error => this.handleError(error))
    },
    dateSelected(dayObject) {
      this.selectedDate = DateTime.local(dayObject.year, dayObject.month, dayObject.day, 0)
      this.updateBlockedTimes()
    },
    blockDay() {
      this.$api.post('/calendar', {
        date: this.selectedDate.toFormat('yyyy-MM-dd'),
        startTime: '00:00',
        endTime: '23:59',
        reason: this.reason,
        comment: this.comment
      }).then(response => {
        console.info(response.data)
        this.updateBlockedTimes()
        this.showInfo(this.selectedDate.toFormat('dd.MM.yy') + " ist jetzt blockiert.")
      })
    },
    unblockDay() {
      const id = this.blockedTimes.filter(bt => bt.reason === 'Closed')[0].id
      this.$api.delete(`/calendar/${id}`).then(() => {
          this.updateBlockedTimes()
        this.showInfo(this.selectedDate.toFormat('dd.MM.yy') + " ist wieder freigegeben.")
      })
    },
    sendWeatherWarning() {
      this.$api.post('/admin/trigger-weather-warning-communication', {}, {
        params: {
          date: this.selectedDate.toFormat('yyyy-MM-dd')
        }
      }).then(() => {
        this.showInfo('Wetterwarnungen gesendet.')
      }).catch(err => this.handleError(err))
    }
  },
  components: {
    ReservationDayCalendar,
    StandardLayout, ReservationCalendar
  }
}
</script>

<style type="scss">
</style>


